import axios from "axios";

export const getOptions = async () => {
  const response = await axios.get(
    "/api/option?populate[mainNavigation][populate]=*&populate[callToAction][populate]=*&populate[locations][populate]=*&populate[mainContacts][populate]=*&populate[privacyLinks][populate]=*&populate[socialLinks][populate]=*&populate[subNavigation][populate]=*&populate[collectionsPages][populate][news][populate]=*&populate[collectionsPages][populate][projects][populate]=*&populate[collectionsPages][populate][services][populate]=*&populate[collectionsPages][populate][vacancies][populate]=*&populate[leadGenForm][populate][file][populate]=*"
  );
  return response.data.data.attributes;
};
